import { fetch } from "src/services/apollo-fetch";
import { Query, Mutation } from "../_api";

export default {
    async fetchPreOrderUnit({ commit }, { preOrderId, unitId }) {
        const response = await fetch.query({
            query: Query.preOrderUnit,
            variables: { preOrderId, unitId },
        });
        commit("setSelectedPreOrderUnit", response.data.preOrderUnit);
    },
    async updatePreOrderUnit({ commit }, data) {
        // clean up data
        const unit = { ...data };
        delete unit.id;
        delete unit.customer;
        delete unit.manufacturer;
        const response = await fetch.mutate({
            mutation: Mutation.updatePreOrderUnit,
            variables: { input: unit },
        });
        commit("setSelectedPreOrderUnit", {
            ...data,
            ...response.data.updatePreOrderUnit,
        });
    },
};
